/*
 * @Author: your name
 * @Date: 2020-09-11 09:12:31
 * @LastEditTime: 2020-11-13 10:25:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\src\commons\enums.ts
 */
export enum ServiceStatus {
  SUCCESS = 'success',
  FAILURE = 'error'
}
export enum ResponseCode {
  FAIL = 0,
  SUCCESS = 1
}
export enum OrderStatus {
  FINSH = 0,
  SUCCESS = 1
}
export enum BrushCourseType {
  FaceRecognition = 'FACE_RECOGNITION',
  RandomTest = 'RANDOM_TEST',
  OnlineTest = 'ONLINE_TEST'
}

export enum ContentType {
  Json = 'application/json',
  Urlencoded = 'application/x-www-form-urlencoded',
  FormData = 'multipart/form-data'
}

export enum ConfigModuleValue {
  True = 'TRUE',
  False = 'FALSE'
}

export enum ConfigModuleName {
  StudentName = 'student_name'
}

export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE'
}

export enum FaceTestResult {
  Success = 'NORMAL',
  Fail = 'UNUSUAL'
}

export enum VideoStatus {
  Finished = 'COMPLETE',
  Unfinished = 'UNFINISHED'
}

export enum LoginUserType {
  Enterprise = 'enterprise',
  Personal = 'personal'
}

export enum StudentStatus {
  PASS = '通过',
  FAIL = '未通过',
  DUPLICATION = '手机号或身份证号已存在'
}

export enum NewsModName {
  Notice = '通知公告',
  Industry = '行业动态',
  Policy = '政策法规'
}
